<template>
  <div class="container">
    <PublicHeader :totalName="$t('share').Invitationrecord" />
    <!-- 顶部 -->
    <div class="top">
      <!-- tab切换 -->
      <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}{{ active ==
            item.value ? total : ''
          }}</span></div>
    </div>
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getInviteLog" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`" @click="showOrderInfo = true">
          <div class="name">{{ dItem.memberName | truncateString }}</div>
          <div class="time">{{ dItem.createTime | getLocalTime }}</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'
import userApi from '@/api/user'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      showOrderInfo: false,
      showSetInfo: false,
      StopSurplusPrice: '',
      StopLossPrice: '',
      active: "1",
      tabs: [{
        name: this.$t('share').Firstlevelmembers,
        value: "1",
      }, {
        name: this.$t('share').Secondlevelmembers,
        value: "2",
      }, {
        name: this.$t('share').Thirdlevelmembers,
        value: "3",
      },
      ],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 5,
      },
      oList: [],
      total: 0,
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getInviteLog()
  },
  methods: {
    changeTab(val) {
      this.active = val
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getInviteLog()
    },
    // 获取邀请记录
    async getInviteLog() {
      if (this.isRun) return
      this.isRun = true
      this.parms.type = this.active
      const res = await userApi.getInviteLog(this.parms)
      this.total = res.total
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 0 15px 0;
  background: var(--background_color);

  .top {
    width: 100%;
    position: fixed;
    background: var(--background_color);

    .tabs {
      padding: 15px;
      border-bottom: 1px solid var(--info_color);
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--ntext_color);
      font-size: 14px;
      font-weight: bold;

      .active {
        color: var(--primary_color);
      }
    }
  }

  .listInfo {
    margin: 65px 15px 0 15px;

    .item {
      margin-top: 30px;

      .name {
        font-size: 14px;
        color: var(--text_color);
      }

      .time {
        margin-top: 10px;
        font-size: 12px;
        color: var(--ntext_color);
      }
    }
  }
}
</style>
